import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { accountApplicationGroupSchema } from '../schemas/account-application-group.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Gets a list of assigned products and groups of product roles allowed per product for an account
 * @param accountId Id of the Account
 * @returns List of assigned products and groups of product roles allowed per product
 */
export function getProductsRolesAccountsV2(this: unknown, accountId: number) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsRolesAccountsV2Url
      }/${encodeURIComponent(accountId)}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(accountApplicationGroupSchema),
      })
    )
  );
}
